module.exports = "<div class=\"applicationBar layout\">\n    <nps-application-bar></nps-application-bar>\n    <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ApplicationBar/applicationBarLayout.html
// module id = 1152
// module chunks = 0